import React from 'react';
import '../../styles/cta_nav.scss';
import './ra_upgrade_banner.scss';

const RaUpgradeBanner = () => {
  return (
    <div className='pt-2 pb-2 ps-3 pe-3 ra-upgrade text-center'>
      <div className='cta-nav-btn-wrapper'>
        <a
          href='https://pgs.devex.com/recruitment-account'
          className='cta-nav-link'
          target='_blank'
          rel='noreferrer'
        >
          Want to see your organization on this list? <strong>Contact us.</strong>
        </a>
      </div>
    </div>
  );
};

export default RaUpgradeBanner;
